import { FormikHelpers } from "formik";
import { TFunction } from "i18next";
import { List } from "immutable";
import { OpenRightPanel } from "types/common/rightPanel";
import { PackOptionsFormValues } from "types/StorageForms/PackOptions";
import {
  toastResponseError,
  toastResponseSuccess,
} from "utils/responseMessageHelper";

export const packOptionsFormik = (
  t: TFunction,
  openRightPanel: OpenRightPanel,
  detailedShipment: any,
  outgoingDetailedShipment: any,
  panelData: any,
  updateAddons: (
    id: string,
    data: { addon_ids: any },
    inventoryId: string | null,
  ) => Promise<any>,
) => {
  const getInitialValues = () => {
    const shipmentId = panelData.get("id");
    const useInventoryAddons = panelData.get("useInventoryAddons");
    const originalItem = panelData.get("originalItem");
    const inventoryId = originalItem?.get("id");
    const detailedItem =
      detailedShipment.get(shipmentId) ||
      outgoingDetailedShipment.get(shipmentId);
    const shipmentItems = detailedItem?.get("items") || List();
    const inventoryItem = useInventoryAddons
      ? shipmentItems.find((item: any) => item.get("id") === inventoryId) ||
        originalItem
      : null;
    const activeItemId =
      useInventoryAddons && inventoryId ? inventoryId : shipmentId;
    const addons =
      (useInventoryAddons
        ? inventoryItem?.get("addons")
        : detailedItem?.get("addons")) || List();

    return {
      activeItem: { value: activeItemId },
      [activeItemId]: addons,
    };
  };

  const initialValues = getInitialValues();

  return {
    enableReinitialize: true,
    initialValues,
    onSubmit: (
      values: PackOptionsFormValues,
      { setSubmitting }: FormikHelpers<PackOptionsFormValues>,
    ) => {
      const shipmentId = panelData.get("id");
      const activeItemId = values.activeItem.value || shipmentId;
      const returnScreen = panelData.get("returnScreen");
      const useInventoryAddons = panelData.get("useInventoryAddons");

      if (useInventoryAddons) {
        const inventoryId = panelData.get("originalItem").get("id");

        return updateAddons(
          shipmentId,
          {
            addon_ids: values[activeItemId],
          },
          inventoryId,
        )
          .then(() => {
            toastResponseSuccess(
              t("parcels.packOptionsSaved", {
                number: panelData.get("description"),
              }),
            );
            openRightPanel(returnScreen, panelData);
          })
          .catch((error: Error) => toastResponseError(error))
          .finally(() => setSubmitting(false));
      }

      return updateAddons(
        shipmentId,
        {
          addon_ids: values[activeItemId],
        },
        null,
      )
        .then(() => {
          toastResponseSuccess(
            t("parcels.packOptionsSaved", {
              number: panelData.get("description"),
            }),
          );
          openRightPanel(returnScreen, panelData);
        })
        .catch((error: Error) => toastResponseError(error))
        .finally(() => setSubmitting(false));
    },
  };
};
